export default __webpack_public_path__ + "static/media/marseille-hightlited-2x.cb8d28d3.webp";